const CountryCode = {
    US: 'us'
}

module.exports = {
    CountryCode
}